export const fr = {
  common: {
    app: {
      ownerName: "Riccardo",
      logoAlt: "Logo BlackFlag",
      homeLinkAriaLabel: "Aller a la page d'accueil",
    },
    navigation: {
      ariaLabel: "Navigation principale",
      home: "Accueil",
      projects: "Projets",
      skills: "Competences",
      about: "A propos",
      playground: "Playground",
      contact: "Contact",
      openMenu: "Ouvrir le menu de navigation",
      switchThemeToLight: "Passer au theme clair",
      switchThemeToDark: "Passer au theme sombre",
      switchLanguage: "Changer de langue",
    },
    languages: {
      it: "IT",
      en: "EN",
      fr: "FR",
    },
    aboutPage: {
      eyebrow: "Profil",
      title:
        "Une base solide entre discipline, ingenierie logicielle et systemes evolutifs",
      imageAlt: "Portrait de Riccardo Licciardi",
      presentation: {
        eyebrow: "Video de presentation",
        title: "Une presentation rapide de mon profil en 2 minutes",
        frameTitle: "Video de presentation de Riccardo Licciardi",
      },
      paragraphs: {
        first:
          "Riccardo Licciardi est Frontend Engineer avec 5 ans d'experience dans le developpement d'applications web evolutives pour des plateformes a fort trafic. Il travaille avec React et Angular sur des produits complexes, ou le refactoring structurel, la qualite du code et la maintenabilite sont des leviers concrets pour ameliorer les performances et la durabilite dans le temps.",
        second:
          "Ces dernieres annees, il a consolide une approche orientee vers l'architecture modulaire, la clarte des workflows et l'evolution progressive de codebases complexes. Aujourd'hui, il etend son profil vers le fullstack, en integrant Node.js, Python, FastAPI ainsi que des competences en AI, LLM, STT/TTS et communication temps reel.",
        third:
          "Avant le logiciel, il a servi dans l'Armee italienne au sein du 4e Regiment de Parachutistes Alpins, dans les Forces d'Operations Speciales. La discipline, le sens des responsabilites et la determination acquis dans ce parcours font aujourd'hui partie de sa maniere d'aborder les projets, les equipes et les decisions techniques.",
      },
    },
    homeSkillsCard: {
      tabs: {
        frontend: "Frontend",
        backend: "Backend",
        goals: "Objectifs futurs",
      },
      sections: {
        frontend: {
          eyebrow: "Stack Frontend",
          title: "Des interfaces soignees",
          description:
            "Conçoit des front-ends scalables en organisant des bases de code complexes via des architectures modulaires et du refactoring, améliorant la performance, la maintenabilité et la vitesse d'évolution du produit.",
        },
        backend: {
          eyebrow: "Stack Backend",
          title: "Une logique applicative fiable",
          description:
            "En phase d'expansion vers le backend et l'intelligence artificielle, il consolide les compétences nécessaires pour orchestrer des processus métier complexes, des pipelines vocaux en temps réel et des flux de données structurés pour l'automatisation.",
        },
        goals: {
          eyebrow: "Objectifs futurs",
          title: "Plus de profondeur et de portee",
          description:
            "Je travaille a renforcer le system design, la maitrise du cloud et ma confiance full-stack au fil du temps.",
        },
      },
      skills: {
        react: "React",
        typescript: "TypeScript",
        materialUi: "Material UI",
        htmlCss: "HTML / CSS",
        nodejs: "Node.js",
        express: "Express",
        restApi: "Conception d'API REST",
        sqlDataModeling: "SQL / Modelisation des donnees",
        java: "Java",
        csharp: "C# / .NET",
        cloudDevops: "Cloud et DevOps",
        systemDesign: "System Design",
      },
      buttons: {
        viewProjects: "Voir les projets",
        contactMe: "Me contacter",
        details: "Details",
      },
    },
    skillsPage: {
      eyebrow: "Competences",
      title: "Stack actif, outils cles et trajectoire d'evolution",
      description:
        "Une vue plus large des technologies que j'utilise pour construire des interfaces, des integrations backend et des workflows en evolution. Chaque bloc reste compact : focus pratique, contexte d'usage et stack associe.",
      searchPlaceholder: "Rechercher React, FastAPI, Docker, PostgreSQL...",
      searchButton: "Rechercher",
      searchAriaLabel: "Rechercher des technologies",
      emptyStateTitle: "Aucune technologie trouvee",
      emptyStateDescription:
        "Essayez un autre tag ou videz la recherche pour voir l'ensemble des competences.",
      sections: {
        frontend: {
          eyebrow: "Frontend",
          title: "UI modulaires et produits a forte maintenance",
          description:
            "Technologies et bibliotheques utilisees pour construire des interfaces evolutives, affiner les composants et gerer des codebases complexes.",
        },
        backend: {
          eyebrow: "Backend & AI",
          title: "Services, integrations et pipelines temps reel",
          description:
            "Stack utilise pour les API, l'orchestration de processus et les workflows conversationnels ou guides par les donnees.",
        },
        goals: {
          eyebrow: "Objectifs futurs",
          title: "Croissance fullstack et profondeur architecturale",
          description:
            "Domaines que je consolide pour gagner en autonomie end-to-end, en qualite systemique et en solidite projet.",
        },
      },
      tags: {
        react: "React",
        reduxToolkit: "Redux Toolkit",
        vite: "Vite",
        typescript: "TypeScript",
        angular: "Angular",
        kendoUi: "Kendo UI",
        restApi: "REST APIs",
        javascript: "JavaScript",
        materialUi: "Material UI",
        tailwindCss: "Tailwind CSS",
        htmlCss: "HTML / CSS",
        figma: "Figma",
        nodejs: "Node.js",
        python: "Python",
        fastapi: "FastAPI",
        openaiApi: "OpenAI API",
        geminiApi: "Gemini API",
        websockets: "WebSockets",
        asterisk: "Asterisk",
        sttTts: "STT / TTS",
        postgresql: "PostgreSQL",
        docker: "Docker",
        cicd: "CI/CD",
        git: "Git",
        cloud: "Cloud",
        systemDesign: "System Design",
        csharp: "C# / .NET",
        sqlServer: "SQL Server",
        architecture: "Architecture modulaire",
        observability: "Observability",
        llm: "LLM",
      },
      items: {
        frontend: {
          react: {
            title: "React Ecosystem",
            summary:
              "Interfaces modulaires, refactoring et scalabilité pour produits complexes.",
          },
          angular: {
            title: "Angular Enterprise",
            summary:
              "Plateformes enterprise, tableaux de bord et workflows complexes.",
          },
          typescript: {
            title: "TypeScript First",
            summary:
              "Typage fort pour réduire les régressions et améliorer la maintenabilité.",
          },
          ui: {
            title: "UI Systems",
            summary:
              "Design systems cohérents, composants réutilisables et développement responsive.",
          },
        },
        backend: {
          node: {
            title: "Node.js Services",
            summary:
              "Logique serveur et services full-stack axés sur l'efficacité opérationnelle.",
          },
          python: {
            title: "Python & FastAPI",
            summary:
              "API légères, orchestration de processus et intégrations IA avancées.",
          },
          realtime: {
            title: "Real-Time Voice Workflows",
            summary:
              "Pipelines conversationnels et automatisation événementielle pour l'IA Vocale.",
          },
          data: {
            title: "Data & Delivery",
            summary:
              "Persistance, conteneurs et CI/CD pour des environnements stables et évolutifs.",
          },
        },
        goals: {
          architecture: {
            title: "System Design",
            summary:
              "Analyse des compromis, modularité et scalabilité de systèmes complexes.",
          },
          cloud: {
            title: "Cloud & DevOps",
            summary:
              "Consolidation du déploiement et des pipelines pour la livraison continue.",
          },
          dotnet: {
            title: "C# / .NET",
            summary:
              "Expansion vers le backend enterprise et les intégrations fortement typées.",
          },
          ai: {
            title: "AI Reliability",
            summary:
              "Optimisation des workflows LLM et STT/TTS avec un focus sur la robustesse.",
          },
        },
      },
    },
    homeIntro: {
      chip: "Frontend Engineer",
      title: "Riccardo Licciardi",
      description:
        "Frontend Engineer axe sur la scalabilite, la maintenabilite et la qualite architecturale. Il conçoit des produits web solides et evolue vers un profil fullstack avec un focus sur l'AI et les systemes temps reel.",
      rotatingSentences: {
        first:
          "Architectures modulaires pour des produits complexes a forte maintenance",
        second: "Refactoring qui ameliore performance et maintenabilite",
        third: "Workflows AI et systemes temps reel orientes execution",
      },
    },
    homeContact: {
      eyebrow: "Contact",
      title: "Parlons produit, architecture ou nouvelles collaborations",
      description:
        "Si vous construisez une plateforme web, une interface complexe ou un workflow temps reel avec integration AI, vous pouvez me contacter directement ici. Je privilegie des conversations claires, rapides et orientees execution.",
      items: {
        email: {
          label: "Email",
          helper: "Touchez pour copier l'adresse email",
        },
        phone: {
          label: "Telephone",
          helper: "Touchez pour copier le numero de telephone",
        },
      },
      copied: "Copie dans le presse-papiers",
      cta: "Aller a la page contact",
    },
    contactPage: {
      eyebrow: "Contact",
      title: "Contact direct et message rapide",
      description:
        "Si vous souhaitez echanger sur un projet, une collaboration ou une idee a transformer en produit, vous trouverez ici mes coordonnees directes ainsi qu'un moyen simple d'ouvrir immediatement un email pre-rempli.",
      copied: "Copie dans le presse-papiers",
      open: "Ouvrir",
      items: {
        email: {
          label: "Email",
          helper: "Touchez pour copier l'adresse email",
        },
        phone: {
          label: "Telephone",
          helper: "Touchez pour copier le numero de telephone",
        },
      },
      form: {
        eyebrow: "Message",
        title: "Envoyer un message direct",
        description:
          "Ce formulaire ouvre votre client email avec les informations deja remplies afin de me contacter rapidement sans backend dedie.",
        fields: {
          name: "Nom",
          email: "Email",
          message: "Message",
        },
        submit: "Ouvrir le brouillon email",
        reset: "Reinitialiser",
        subjectPrefix: "Contact portfolio de",
        fallbackContactName: "un nouveau contact",
        bodyLabels: {
          name: "Nom",
          email: "Email",
        },
      },
    },
    homeProjects: {
      eyebrow: "Projets selectionnes",
      title: "Trois apercus rapides de mon travail",
      description:
        "Une selection compacte de projets qui montre du refactoring architectural, des systemes Voice AI temps reel et des outils full-stack orientes donnees.",
      previewLabel: "Apercu",
      viewAll: "Voir tous les projets",
      items: [
        {
          title: "Plateforme de vote numerique (Opinio)",
          category: "Frontend a grande echelle",
          description:
            "Refonte complete du frontend pour une plateforme electorale de plus de 800 000 utilisateurs.",
          tags: ["React", "Redux Toolkit", "Vite"],
        },
        {
          title: "AI Voice PBX",
          category: "Voice AI temps reel",
          description:
            "Central telephonique intelligent multi-tenant avec pipeline STT, LLM et TTS.",
          tags: ["Python", "FastAPI", "Asterisk"],
        },
        {
          title: "Restaurant Expense Analyzer",
          category: "Analyse full-stack",
          description:
            "Analyse automatisee de factures PDF avec AI et tableaux de bord interactifs.",
          tags: ["React", "Node.js", "TypeScript"],
        },
        {
          title: "Plateforme Retail DINAMO",
          category: "Microservices retail",
          description:
            "Plateforme retail pour caisse, stock et workflows operationnels a grande echelle.",
          tags: ["Angular", "Kendo UI", "REST APIs"],
        },
        {
          title: "Plateforme de formation professionnelle (CNAPPC)",
          category: "Dashboards multi-roles",
          description:
            "Gestion des credits CFP et des achats pour plus de 100 000 professionnels.",
          tags: ["React", "TypeScript", "REST APIs"],
        },
        {
          title: "Gestion d'ateliers & cartes temps reel",
          category: "Cartes et tracking temps reel",
          description:
            "Suivi des travaux par QR code avec visualisation geospatiale temps reel.",
          tags: ["Node.js", "PostgreSQL", "Leaflet"],
        },
      ],
    },
    testimonials: {
      eyebrow: "Temoignages",
      title: "Retours provenant de contextes projet complexes",
      description:
        "Une selection de retours qui met en avant la fiabilite, la vision projet et la capacite a transformer des besoins complexes en solutions techniques solides.",
      items: [
        {
          author: "Michele Albertini",
          role: "CEO Didanet",
          quote:
            "Riccardo s'est distingue par une forte initiative personnelle et une vision projet solide, en maintenant des standards de qualite eleves meme dans des contextes techniques complexes.",
        },
        {
          author: "V3L Studio",
          role: "Studio de conseil et developpement",
          quote:
            "Collaborer avec Riccardo est devenu un atout strategique pour notre studio. Il sait transformer des visions complexes en architectures solides et piloter des projets Voice AI et temps reel avec autonomie.",
        },
        {
          author: "Dre Elena V.",
          role: "Notaire",
          quote:
            "Riccardo a su traduire les exigences de fiabilite et de rigueur en un site institutionnel clair, autoritaire et techniquement tres bien execute.",
        },
        {
          author: "Dr Valerio Noto",
          role: "Notaire",
          quote:
            "Sa precision technique et son souci du detail ont depasse mes attentes, en communiquant parfaitement l'autorite de mon cabinet.",
        },
        {
          author: "Bea",
          role: "Guide spirituelle & mentor",
          quote:
            "Riccardo a donne vie a ma vision en combinant complexite technique et experience utilisateur apaisante, avec une vraie sensibilite pour l'ame du projet.",
        },
      ],
    },
    projects: {
      eyebrow: "Projets et experience",
      title:
        "Plateformes evolutives, voice AI et workflows guides par les donnees",
      description:
        "Une selection de projets couvrant refactoring architectural, produits a fort trafic, plateformes full-stack et systemes temps reel integres avec l'AI.",
      previewLabel: "Projet",
      openDetails: "Ouvrir les details",
      close: "Fermer",
      stackLabel: "Stack",
      detailsLabel: "Details",
      items: [
        {
          title: "Plateforme de vote numerique (Opinio)",
          role: "Frontend Engineer",
          category: "Frontend a grande echelle",
          description:
            "Riccardo a pilote la transition d'une base legacy obsolete vers une plateforme web moderne et evolutive, en reconstruisant l'architecture frontend avec une approche modulaire en React pour recuperer les retards et ameliorer la maintenabilite.",
          details: [
            "Transition critique d'une architecture legacy obsolete vers une plateforme web moderne et evolutive.",
            "Reconstruction complete du frontend avec une approche modulaire et les bonnes pratiques React.",
            "Support de processus electoraux securises pour plus de 800 000 utilisateurs.",
          ],
          stack: [
            "React",
            "Redux Toolkit",
            "Vite",
            "Material UI",
            "Blockchain",
          ],
        },
        {
          title: "AI Voice PBX",
          role: "Fullstack / AI Engineer",
          category: "Voice AI temps reel",
          description:
            "Riccardo a concu une plateforme voice AI multi-tenant capable de gerer des conversations telephoniques en temps reel, d'extraire des donnees structurees via des custom tools et de declencher des workflows metier automatises.",
          details: [
            "Plateforme voice AI evolutive pour l'accueil telephonique automatise et la collecte de donnees.",
            "Pipeline temps reel STT → LLM → TTS avec extraction structuree via custom tools.",
            "Architecture multi-tenant pensee pour des workflows metier et plusieurs secteurs verticaux.",
          ],
          stack: [
            "Python",
            "FastAPI",
            "Asterisk",
            "Gemini STS",
            "OpenAI API",
            "Docker",
            "PostgreSQL",
          ],
        },
        {
          title: "Restaurant Expense Analyzer",
          role: "Fullstack Developer",
          category: "Analyse full-stack",
          description:
            "Riccardo a developpe un outil full-stack pour l'analyse automatisee de factures PDF non structurees, combinant extraction par AI, dashboards interactifs et workflows d'export pour aider la comptabilite.",
          details: [
            "Chargement massif de factures PDF avec extraction granulaire automatisee via AI.",
            "Dashboards interactifs pour agreger les couts et visualiser la repartition des depenses.",
            "Workflows d'export pensés pour soutenir des decisions comptables et operationnelles.",
          ],
          stack: [
            "React",
            "Node.js",
            "TypeScript",
            "Tailwind CSS",
            "Recharts",
            "LLM Integration",
          ],
        },
        {
          title: "Plateforme Retail DINAMO",
          role: "Frontend Engineer",
          category: "Microservices retail",
          description:
            "Riccardo a contribue au developpement d'une plateforme retail basee sur des microservices pour la caisse et le stock, en implementant des fonctionnalites metier et en ameliorant l'efficacite de composants legacy.",
          details: [
            "Developpement de fonctionnalites pour la caisse et la gestion de stock dans une architecture microservices.",
            "Integration d'endpoints complexes pour des systemes de vente et de logistique.",
            "Amelioration de l'efficacite de composants legacy dans des workflows retail a forte activite.",
          ],
          stack: ["Angular", "Kendo UI", "REST APIs"],
        },
        {
          title: "Plateforme de formation professionnelle (CNAPPC)",
          role: "Frontend Engineer",
          category: "Dashboards multi-roles",
          description:
            "Riccardo a concu et realise des fonctionnalites cles pour la gestion des credits CFP et des dashboards multi-roles, en construisant des parcours d'achat et de suivi pour plus de 100 000 professionnels.",
          details: [
            "Conception de fonctionnalites pour le suivi des credits CFP.",
            "Creation de dashboards multi-roles pour Ordres, Fournisseurs et Professionnels.",
            "Implementation de parcours d'achat et de suivi pour plus de 100 000 inscrits.",
          ],
          stack: ["React", "TypeScript", "REST APIs"],
        },
        {
          title: "Gestion d'ateliers & cartes temps reel",
          role: "Fullstack Developer",
          category: "Cartes et tracking temps reel",
          description:
            "Riccardo a developpe une plateforme de suivi des travaux via QR code et une carte geospatiale interactive pour le reseau de chauffage urbain d'Asiago, en combinant logique backend, donnees territoriales et visualisation temps reel.",
          details: [
            "Plateforme de suivi des activites via QR codes.",
            "Carte geospatiale interactive pour la gestion du reseau de chauffage urbain d'Asiago.",
            "Integration entre logique backend, donnees territoriales et visualisation temps reel.",
          ],
          stack: ["Node.js", "PostgreSQL", "Leaflet", "JavaScript"],
        },
      ],
    },
  },
} as const;
